import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';
import PdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { PDFDocument } from 'pdf-lib';
import { ActivatedRoute } from '@angular/router';
import { MeetingDetailsService } from '../../services/meeting-details.service';
import { InviteeMeetingInvitaionStatus } from '../../models/meeting/InviteeMeetingInvitaionStatus';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PDFViewerService } from './service/PDFViewer.service';
// pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
pdfjsLib.GlobalWorkerOptions.workerSrc = PdfjsWorker;
export enum Source {
  Meetings = 'Meetings',
  Messages = 'Messages',
  SignDocs = 'SignDocs'
}

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter();
  @ViewChild('pdfContainer', { static: true }) pdfContainer: ElementRef<HTMLDivElement>;
  @ViewChild('textDropdown', { static: true }) textDropdown: ElementRef<HTMLSelectElement>;

  dataLoading = true;
  loading: string;

  source: Source = Source.Meetings;
  documentId: number;
  relatedToId: number;
  relatedParentId: number;

  details: any;

  private pdfDoc: any;
  private pdfLibDoc: PDFDocument;
  @Input() insertedOptions: {
    text: string,
    userId: number,
    isSigned?: boolean,
    signatureImg?: string,
    userName?: string,

    x: number,
    y: number,
    width: number,
    height: number,
    pageIndex: number
  }[] = [];
  scale = 1.85;

  private ctx: CanvasRenderingContext2D;
  private currentPageBeforeLastDrawing;
  private isDrawing = false;
  private coordinates = { x: 0, y: 0, width: 0, height: 0 };

  @Input() document: any;
  @Input() optionsList: any[] = [];
  showUsersPopup = false;
  selectedUser: any = null;

  private signatureDim = { width: 100, hegiht: 100 };
  selectedPageIndex = 0;

  isConfig = false;
  searchUser = '';

  insertedOptionsCopy: any;

  constructor(
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private service: MeetingDetailsService,
    private pdfService: PDFViewerService,
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    if (this.document) {
      this.previewPdf();
    } else {
      this.route.queryParams.subscribe(params => {
        if (params['source']) {
          this.source = params['source'];
        }
      })
      this.route.paramMap.subscribe(params => {
        this.documentId = Number(params.get('documentId'));
        this.relatedToId = Number(params.get('relatedToId'));
        this.relatedParentId = Number(params.get('relatedParentId'));
        this.getDetails();
        if (this.relatedParentId) {
          this.isConfig = true;
          this.listInvitees();
        }
      });
    }
  }

  previewPdf() {
    this.isConfig = true;
    if (this.insertedOptions.length) { // Edit
      this.insertedOptionsCopy = [...this.insertedOptions];
      this.details = { users: this.insertedOptions };
      this.insertedOptions = [];
    }

    const file = this.document;
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const typedArray = new Uint8Array(fileReader.result as ArrayBuffer);
      this.loadPdf(typedArray);
    };
    fileReader.readAsArrayBuffer(file);
  }

  getDetails() {
    let data: any = {
      documentId: this.documentId,
    };
    if (this.source == Source.Meetings) {
      data.agendaItemId = this.relatedToId;
    }
    if (this.source == Source.Messages || this.source == Source.SignDocs) {
      data.messageItemId = this.relatedToId;
    }
    this.pdfService.getDocDetails(data, this.source).subscribe(
      (result: any) => {
        if (result) {
          this.dataLoading = false;
          this.details = result;
          if (result.attachment.path) {
            this.loadPdf(result.attachment.path);
          }
        }
      },
      err => {
        this.dataLoading = false;
        console.error(err);
      }
    );
  }
  listInvitees() {
    let inviteeFilter: any = {};
    inviteeFilter.pageNumber = 0;
    inviteeFilter.pageSize = 100;
    inviteeFilter.inviteeStatus = InviteeMeetingInvitaionStatus.Accept;
    inviteeFilter.meetingId = this.relatedParentId;
    inviteeFilter.isAttendeeView = false;
    this.service.ListInvitees(inviteeFilter).subscribe(
      result => {
        this.optionsList = result.pageData;
      },
      err => {
        console.error(err);
      }
    );
  }

  private pdfPageImage: ImageData;
  async loadPdf(url: any) {
    this.dataLoading = true;
    const loadingTask = pdfjsLib.getDocument(url);
    this.pdfDoc = await loadingTask.promise;
    if (!this.document) {
      const pdfBytes = await fetch(url).then(res => res.arrayBuffer());
      this.pdfLibDoc = await PDFDocument.load(pdfBytes);
    }

    for (let i = 1; i <= this.pdfDoc.numPages; i++) {
      const page = await this.pdfDoc.getPage(i);
      await this.renderPage(i, page);
    }

    if (this.isConfig) {
      this.bindConfiguration();
    } else {
      this.insertedOptions = this.details.users;
      this.applySignature();
    }

    this.dataLoading = true;
  }

  async renderPage(pageNum: number, page: any) {
    const viewport = page.getViewport({ scale: this.scale });
    const canvas = this.renderer.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    // this.renderer.listen(canvas, 'click', (event) => this.onCanvasClick(event, pageNum - 1));
    this.renderer.listen(canvas, 'mousedown', (event) => this.onMouseDown(event, pageNum - 1));
    this.renderer.listen(canvas, 'mousemove', (event) => this.onMouseMove(event));
    this.renderer.listen(canvas, 'mouseup', (event) => this.onMouseUp(event));

    const pdfContainer = this.pdfContainer.nativeElement;
    this.renderer.appendChild(pdfContainer, canvas);
    await page.render(renderContext).promise;
  }

  onMouseDown(event: MouseEvent, pageIndex: number) {
    this.isDrawing = true;
    this.coordinates.x = event.offsetX;
    this.coordinates.y = event.offsetY;
    this.selectedPageIndex = pageIndex;

    const canvas = <HTMLCanvasElement>this.pdfContainer.nativeElement.children[pageIndex];
    this.ctx = canvas.getContext('2d');

    this.currentPageBeforeLastDrawing = this.ctx.getImageData(0, 0, canvas.width, canvas.height);
    this.pdfPageImage = this.ctx.getImageData(0, 0, canvas.width, canvas.height);
    this.ctx.strokeStyle = '#1B9AFF';
    this.ctx.lineWidth = 1;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDrawing) return;

    this.coordinates.width = event.offsetX - this.coordinates.x;
    this.coordinates.height = event.offsetY - this.coordinates.y;

    // console.log(event.offsetY);

    this.ctx.putImageData(this.pdfPageImage, 0, 0);
    this.ctx.strokeRect(this.coordinates.x, this.coordinates.y, this.coordinates.width, this.coordinates.height);
  }

  onMouseUp(event: MouseEvent) {
    this.isDrawing = false;
    if (this.coordinates.width < 0) {
      this.coordinates.x = this.coordinates.x + this.coordinates.width;
      this.coordinates.width = Math.abs(this.coordinates.width);
    }
    if (this.coordinates.height < 0) {
      this.coordinates.y = this.coordinates.y + this.coordinates.height;
      this.coordinates.height = Math.abs(this.coordinates.height);
    }

    if (Math.abs(this.coordinates.width) < 30 || Math.abs(this.coordinates.height) < 30) {
      this.ctx.putImageData(this.currentPageBeforeLastDrawing, 0, 0);
      this.coordinates = { x: 0, y: 0, width: 0, height: 0 };
      Swal.fire({
        icon: 'warning',
        text: this.translate.instant('swalMsg.Please select a larger space!'),
        confirmButtonText: this.translate.instant('swalMsg.ok'),
      })
    } else {
      this.showUsersPopup = true;
    }
  }

  async bindConfiguration() {
    this.dataLoading = true;
    setTimeout(() => {
      this.details?.users.forEach(element => {
        this.addTextToDoc(element);
      });
      this.dataLoading = false;
    }, 1000);
  }
  addTextToDoc(selectedOption, addRect = true) {
    let selectedPage = Number(this.selectedPageIndex || selectedOption.pageIndex || 0);
    const canvas = <HTMLCanvasElement>this.pdfContainer.nativeElement.children[selectedPage];
    this.ctx = canvas.getContext('2d');
    this.ctx.strokeStyle = '#1B9AFF';
    this.ctx.lineWidth = 1;
    if (addRect) {
      this.ctx.strokeRect(
        Number(selectedOption.x), Number(selectedOption.y),
        Number(selectedOption.width), Number(selectedOption.height));
    }
    this.ctx.fillText(
      selectedOption.fullName || selectedOption.userName || selectedOption.text,
      Number(this.coordinates.x || selectedOption.x) + 5,
      Number(this.coordinates.y || selectedOption.y) + 10
    );
    this.insertedOptions.push({
      text: selectedOption.fullName || selectedOption.text,
      userId: selectedOption.userId || selectedOption.id,
      signatureImg: selectedOption.signatureImg,
      x: this.coordinates.x || selectedOption.x,
      y: this.coordinates.y || selectedOption.y,
      width: this.coordinates.width || selectedOption.width,
      height: this.coordinates.height || selectedOption.height,
      pageIndex: selectedPage
    });
    this.coordinates = { x: 0, y: 0, width: 0, height: 0 };
  }

  signatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg"
  };
  detectMimeType(b64) {
    for (var s in this.signatures) {
      if (b64.indexOf(s) === 0) {
        return this.signatures[s];
      }
    }
  }
  async applySignature() {
    this.dataLoading = true;
    const pages = this.pdfLibDoc.getPages();

    for (let i = 0; i < pages.length; i++) {
      const page = pages[i];
      const canvas = <HTMLCanvasElement>this.pdfContainer.nativeElement.children[i];
      const imageData = canvas.toDataURL('image/png');
      const pngImageBytes = await fetch(imageData).then(res => res.arrayBuffer());
      const pngImage = await this.pdfLibDoc.embedPng(pngImageBytes);

      const { width, height } = page.getSize();
      page.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: width,
        height: height,
      });

      for (const option of this.insertedOptions) {
        if (Number(option.pageIndex) === i && option.signatureImg && option.isSigned) {
          let imageBase64;
          let embeddedImage;
          if (this.detectMimeType(option.signatureImg) == 'image/png') {
            imageBase64 = 'data:image/png;base64,' + option.signatureImg;
            embeddedImage = await this.pdfLibDoc.embedPng(imageBase64);
          } else {
            imageBase64 = 'data:image/png;base64,' + option.signatureImg;
            embeddedImage = await this.pdfLibDoc.embedJpg(imageBase64);
          }
          if (embeddedImage) {
            var imgAspectRatio = (embeddedImage.width / embeddedImage.height);
            var rect = {
              width: Number(option.width) / this.scale,
              height: Number(option.height) / this.scale
            };
            var rectAspectRatio = rect.width / rect.height;
            var drawWidth, drawHeight;
            if (imgAspectRatio > rectAspectRatio) {
              // If the image is wider than the rectangle, fit by width
              drawWidth = rect.width;
              drawHeight = rect.width / imgAspectRatio;
            } else {
              // If the image is taller than the rectangle, fit by height
              drawWidth = rect.height * imgAspectRatio;
              drawHeight = rect.height;
            }

            page.drawImage(embeddedImage, {
              x: Number(option.x) / this.scale,
              // y: height - Number(option.y) - rect.height,
              y: height - (Number(option.y) / this.scale) - rect.height,
              width: drawWidth,
              height: drawHeight
            });
          }
        }
      };
    }

    const pdfBytes = await this.pdfLibDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);
    // window.open(pdfUrl, '_blank');
    window.location.href = pdfUrl;
    URL.revokeObjectURL(pdfUrl);

    // this.dataLoading = false;
    // history.back();
  }

  onCanvasClick(event: MouseEvent, pageIndex: number) {
    var rect = document.getElementsByTagName('canvas')[pageIndex].getBoundingClientRect();
    this.coordinates = { x: event.clientX - rect.left, y: event.clientY - rect.top, width: 0, height: 0 };
    this.showUsersPopup = true;
    this.selectedPageIndex = pageIndex;
  }

  selectChanged() {
    if (this.selectedUser) {
      this.addTextToDoc(this.selectedUser, false);

      this.showUsersPopup = false;
      this.selectedUser = null;

      this.snackBar.open(
        this.translate.instant('swalMsg.addedsuccessfully'),
        this.translate.instant('swalMsg.ok'),
        {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top'
        }
      );
    }
  }

  hideOption(item: any) {
    return new RegExp(this.searchUser, 'i').test(item.fullName) === false
  }
  isAllHidden() {
    return this.optionsList.every(item => this.hideOption(item));
  }
  closeChooseUser() {
    this.showUsersPopup = false;
    this.searchUser = '';
    this.selectedUser = null;
    this.ctx.putImageData(this.currentPageBeforeLastDrawing, 0, 0);
  }
  isSelected(option) {
    return this.insertedOptions.some(o => o.userId == option.id);
  }

  saveConfig(reset = false) {
    if (reset) {
      this.insertedOptions = [];
      if (this.document) {
        // this.close.emit(this.insertedOptions);
        if (this.details?.users) {
          this.details.users = [];
        }
        this.pdfContainer.nativeElement.innerHTML = '';
        this.previewPdf();
        return;
      }
    }
    if (this.document) {
      this.save.emit(this.insertedOptions);
      return;
    }

    this.loading = reset ? 'reset' : 'save';
    let data = {
      meetingId: this.relatedParentId,
      documentId: this.documentId,
      users: this.insertedOptions
    }
    this.pdfService.SaveAgindaDocumentSignature(data).subscribe(
      result => {
        this.loading = '';
        if (reset) {
          this.pdfContainer.nativeElement.innerHTML = '';
          this.getDetails();
        }
        Swal.fire({
          title: this.translate.instant('swalMsg.success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.ok'),
        })
      },
      err => {
        this.loading = '';
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: this.translate.instant('meetings.Settings cannot be modified at this time.'),
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.ok')
        })
        console.error(err);
      }
    );
  }
  closeDialog() {
    if (this.document) {
      if (JSON.stringify(this.insertedOptions) != JSON.stringify(this.insertedOptionsCopy)) {
        Swal.fire({
          text: this.translate.instant('docs.Changes will be discard, Are you sure to close?'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.translate.instant('swalMsg.yes'),
          cancelButtonText: this.translate.instant('swalMsg.no')
        }).then((result) => {
          if (result.isConfirmed) {
            this.close.emit(true);
          }
        })
      } else {
        this.close.emit(true);
      }
    } else {
      this.close.emit(true);
    }
  }
}
